import React, { useState, Fragment, useEffect, useCallback } from "react";
import {
    formBtn1,
    formBtn2,
    inputClass,
    labelClass,
} from "../Utils/CustomClasses";
import { useForm, Controller } from "react-hook-form";
import { customStyles } from "../Utils/CommonFuntion";
import { Dialog, Transition } from "@headlessui/react";
import Error from "../Error/Error";
import { Tooltip } from "antd";
import { validateAlternateNumber, validatePhoneNumber } from "../Utils/Validation";
import Select from "react-select";
import { useThemeColor } from "../Sidebar/SideBarApi";
import {
    AddLeadsAPI,
    AssignUserAPI,
    UpdateLeadsAPI,
    UploadCSVAPI,
} from "../../API/Api";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { downloadCSV } from "../Utils/CommonFuntion";
import ButtonLoader from "../Loader/ButtonLoader";
import { IconEdit, IconFiles } from "@tabler/icons-react";

export default function AddLeadd({ edit, rowdata, Company, iniAssignUsers, filterRecords, filterSubmit }) {
    const userDetails = useSelector((state) => state?.login?.userDetails);
    const themeColor = useThemeColor();
    const {
        register,
        handleSubmit,
        control,
        reset,
        watch,
        formState: { errors },
        setValue,
    } = useForm({
        defaultValues: {
            file: null
        }
    });
    const file = watch('leadCSVupload');
    const [isOpen, setIsOpen] = useState(false);
    const [AssignUsers, setAssignUsers] = useState([]);
    const [dragOver, setDragOver] = useState(false); 
    const [csvLoader, setCsvLoader] = useState(false);
    const [manualLoader, setManualLoader] = useState(false);
    const watchCompany = watch("company");
    const [activeTab, setActiveTab] = useState("csv");
    const handleTabChange = (tab) => {
        if (edit) return;
        setActiveTab(tab);
        reset();
    };

    useEffect(() => {
        if (edit) {
            setActiveTab("addManually");
        }
    }, [edit]);

    const excelHeader = [
        "firstName",
        "lastName",
        "email",
        "phoneNumber",
        "alternateNumber",
        "leadSource",
        "city",
        "state",
        "pincode",
        "product",
        "assigned_to",
        "remark",
        "company"
    ];

    const assignToOptions =
        AssignUsers != undefined
            ? AssignUsers.map((user) => ({
                value: user?._id,
                label: `${user?.first_name} ${user?.last_name}`,
            }))
            : [{ value: "", label: "No data found" }];

    let assignChangeTimeout;
    const handleAssignChange = async (selectedOption) => {
        if (assignChangeTimeout) {
            clearTimeout(assignChangeTimeout); // Clear previous timeout if exists
        }

        assignChangeTimeout = setTimeout(async () => {
            try {
                let response = await AssignUserAPI({
                    id: userDetails?._id,
                    role: userDetails?.role?.roleName,
                    search: selectedOption,
                    company: watchCompany,
                });
                setAssignUsers(response?.data?.filteredData);
            } catch (error) {
                console.error("Error assigning user:", error);
            }
        }, 1500); // Delay of 1500ms
    };

    const toggle = () => {
        setIsOpen(!isOpen);
        reset();
    };

    const onSubmit = async (data) => {
        const { file, leadCSVupload, ...rest } = data;
        const payload = {
            ...rest,
            assigned_to: data?.assigned_to?.value,
        };
        if (activeTab === "csv") {
            setCsvLoader(true);
            try {
                const file = data.leadCSVupload[0];
                const text = await file.text();
                const rows = text.trim().split("\n");
                if (rows.length <= 1) {
                    toast.error("CSV file is empty");
                    setCsvLoader(false);
                    return;
                }
                const formData = new FormData();
                formData.append("leadCSVupload", file);
                let response = await UploadCSVAPI(formData);
                if (response?.status == 200) {
                    Swal.fire({
                        title: "CSV Upload Result",
                        html: `
                        <p><strong class="text-base-green">Success:</strong> ${response?.data?.data?.successCount
                            } leads added</p>
                        <p><strong class="text-base-red">Failed:</strong> ${response?.data?.data?.failedCount
                            } leads failed</p>
                         <div style="text-align: -webkit-center">
                         ${response?.data?.data?.failedCount > 0
                                ? `<button id="downloadFailedRecords" class="${formBtn1}" style="margin-top: 10px;">Download Failed Records</button>`
                                : ""
                            }
                      </div>
                    `,
                        icon: response?.data?.data?.failedCount > 0 ? "warning" : "success",
                        confirmButtonText: "OK",
                        allowOutsideClick: false, // Ensures clicking outside closes it
                        customClass: {
                            confirmButton: `${formBtn1}`,
                        },
                        preConfirm: () => {
                            Swal.close(); // Explicitly close on OK
                            setCsvLoader(false);
                            toggle();
                            filterRecords();
                            setAssignUsers([]);
                        },
                        didOpen: () => {
                            document
                                .getElementById("downloadFailedRecords")
                                ?.addEventListener("click", () => {
                                    const headersWithFailureReason = [
                                        ...excelHeader,
                                        "failureReason",
                                    ];
                                    const failedData = response?.data?.data?.failedLeads || [];
                                    downloadCSV(
                                        headersWithFailureReason,
                                        failedData,
                                        "Failed_Leads"
                                    );
                                });
                        },
                    });
                }
            } catch (err) {
                console.log("err", err);
                setCsvLoader(false);
            }
        } else {
            setManualLoader(true);
            try {
                let response;
                if (edit == true) {
                    response = await UpdateLeadsAPI(rowdata?._id, payload);
                } else {
                    response = await AddLeadsAPI(payload);
                }
                if (response?.status == 201) {
                    toast.success(response?.data?.message);
                    setManualLoader(false);
                    toggle();
                    (filterRecords ?? filterSubmit)?.();
                    setAssignUsers([]);
                } else {
                    setManualLoader(false);
                    toast.error(response?.error);
                }
            } catch (err) {
                setManualLoader(false);
                console.log("Error:--", err);
            }
        }
    };

    const handleCompanySelect = async (id) => {
        setValue("assigned_to", null);
        setAssignUsers([]);
        try {
            let response = await AssignUserAPI({
                id: userDetails?._id,
                role: userDetails?.role?.roleName,
                company: id,
            });
            setAssignUsers(response?.data?.filteredData);
        } catch (err) {
            console.log("Error:", err);
        }
    };

    useEffect(() => {
        if (isOpen && activeTab == "addManually" && edit == true) {
            reset({
                firstName: rowdata?.firstName,
                lastName: rowdata?.lastName,
                email: rowdata?.email,
                alternateNumber: rowdata?.alternateNumber || "",
                leadSource: rowdata?.leadSource,
                city: rowdata?.city,
                state: rowdata?.state,
                product: rowdata?.product,
                pincode: rowdata?.pincode,
                company: rowdata?.company?._id,
                assigned_to: rowdata?.assigned_to
                    ? {
                        value: rowdata?.assigned_to?._id,
                        label: `${rowdata?.assigned_to?.first_name} ${rowdata?.assigned_to?.last_name}`,
                    }
                    : null,
            });
        }
        if (isOpen && activeTab == "addManually" && iniAssignUsers && iniAssignUsers.length > 0) {
            setAssignUsers(iniAssignUsers);
        }
        if (isOpen && edit == false && userDetails?.role?.roleName !== "SuperAdmin") {
            setTimeout(() => {
                setValue("company", userDetails?.company?._id);
            }, 500);
        }
    }, [isOpen, activeTab == "addManually"]);

    const handleDragOver = useCallback((e) => {
            e.preventDefault();
            setDragOver(true);
        }, []);
    
        const handleDragLeave = useCallback((e) => {
            e.preventDefault();
            setDragOver(false);
        }, []);
    
        const handleDrop = useCallback((e) => {
            e.preventDefault();
            setDragOver(false);
    
            const droppedFile = e.dataTransfer.files[0];
            if (droppedFile) {
                try {
                validateAndSetFile(droppedFile);
            } catch (error) {
                toast.error(error.message || "Invalid file type. Only CSV files are accepted.");
                console.error(error);
            }
            }
        }, []);
    
        const validateAndSetFile = (selectedFile) => {
            
            const allowedTypes = [
                'text/csv', // .csv
                'application/csv', // .csv
                'text/comma-separated-values', // .csv
                'text/plain' // sometimes CSV files are recognized as plain text
            ];
    
            const fileExtension = selectedFile?.name.split('.').pop().toLowerCase();
            const isAllowedExtension = ['csv']?.includes(fileExtension);
            
    
            if (!allowedTypes.includes(selectedFile?.type) && !isAllowedExtension) {
                reset();
                // toast.error("Invalid file type. Only CSV files are accepted.");
                throw new Error('Please select a valid CSV file (.csv)');
            }
    
            if (selectedFile?.size > 5 * 1024 * 1024) {
                reset();
                // toast.error("File size must be less than 5MB");
                throw new Error('File size must be less than 5MB');
            }
    
             setValue('leadCSVupload', [selectedFile]);
        };
    
        const handleFileSelect = (e) => {
            const selectedFile = e.target.files[0];
            if (selectedFile) {
                try {
                    validateAndSetFile(selectedFile);
                } catch (error) {
                    toast.error(error.message);
                    console.error(error);
                }
            }
        };
     
    return (
        <>
            {edit ? (
                <button
                    onClick={toggle}
                    className="py-1 rounded-lg flex justify-center"
                >
                    <IconEdit stroke={1.5} size={24} color="#000"/>
                </button>
            ) : (
                <>
                    <div className="flex gap-4">
                        <button onClick={toggle} className={formBtn1}>
                            Add Lead
                        </button>
                    </div>
                </>
            )}

            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[100]" onClose={toggle}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>
                    <div className="fixed inset-0 overflow-y-scroll ">
                        <div className="flex items-center justify-center min-h-full p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-2xl text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                    <Dialog.Title
                                        as="h2"
                                        className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                    >
                                        {edit ? "Edit Lead" : "Add Lead"}
                                    </Dialog.Title>
                                    <div>
                                        {activeTab == "csv" && (
                                            <div className="absolute right-[2rem]">
                                                <Tooltip
                                                    title={
                                                        <>
                                                            <div>Download demo CSV file here</div>
                                                        </>
                                                    }
                                                    placement="right"
                                                    color="#032037"
                                                >
                                                    <button
                                                        onClick={() => {
                                                            downloadCSV(excelHeader, [], "DemoAddLead");
                                                        }}
                                                    >
                                                        <IconFiles stroke={2} size={32} color={themeColor} className="cursor-pointer" />
                                                    </button>
                                                </Tooltip>
                                            </div>
                                        )}
                                        <form onSubmit={handleSubmit(onSubmit)}>
                                            {!edit && (
                                                <div className="pt-5 pr-5 pl-5 pb-2">
                                                    <div className=" flex justify-evenly border-b border-gray-300">
                                                        <div className={`flex justify-center w-1/2 ${activeTab === "csv" ? "border-b-2 border-base-color" : ""}`}>
                                                            <button
                                                                type="button"
                                                                className={`px-4  text-sm md:text-base font-medium
                                                                ${activeTab === "csv"
                                                                    ? "text-base-color"
                                                                    : "text-gray-500 hover:text-base-color"}
                                                                `}
                                                                onClick={() => handleTabChange("csv")}
                                                            >
                                                                <span className="text-lg">Upload CSV</span>
                                                            </button>
                                                        </div>
                                                        <div className={`flex justify-center w-1/2 ${activeTab === "addManually" ? "border-b-2 border-base-color" : ""}`}>
                                                            <button
                                                                type="button"
                                                                className={`px-4 py-2 text-sm md:text-base font-medium
                                                                ${activeTab === "addManually"
                                                                    ? "text-base-color"
                                                                    : "text-gray-500 hover:text-base-color"}
                                                                `}
                                                                onClick={() => handleTabChange("addManually")}
                                                            >
                                                                <span className="text-lg">Add Manually</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {activeTab === "csv" ? (
                                                <div className="flex justify-center items-center">
                                                    <div className="p-4 flex flex-col gap-4 items-center">
                                                            <div
                                                                className={`border-2 mt-[15px] border-dashed rounded-xl p-8 text-center transition-all duration-300 ${dragOver
                                                                    ? 'border-base-color bg-blue-50 scale-105'
                                                                    : 'border-gray-300 hover:border-base-color  hover:bg-blue-50'
                                                                    }`}
                                                                onDragOver={handleDragOver}
                                                                onDragLeave={handleDragLeave}
                                                                onDrop={handleDrop}
                                                            >         
                                                            {file &&  file.length > 0 ? (
                                                                <div className="space-y-4">
                                                                    <div>
                                                                        <p className="text-lg font-medium text-gray-800">{file?.[0]?.name}</p>
                                                                        <p className="text-gray-500">
                                                                            {(file?.[0]?.size / 1024 / 1024)?.toFixed(2) || "0.00"} MB
                                                                        </p>
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => reset()}
                                                                        className="text-red-500 hover:text-red-700 font-medium"
                                                                    >
                                                                        Remove file
                                                                    </button>
                                                                </div>
                                                            ) : (
                                                                <div className="space-y-4">
                                                                    <div>
                                                                        <p className="text-lg font-medium text-gray-700 mb-2">
                                                                            Drop your CSV file here or click to browse
                                                                        </p>
                                                                        <p className="text-gray-500">
                                                                            Supports .csv files up to 5MB
                                                                        </p>
                                                                    </div>
                                                                    <input
                                                                        type="file"
                                                                        accept=".csv"
                                                                        {...register('leadCSVupload', {
                                                                            required: 'Please select a file',
                                                                            validate: {
                                                                                fileType: (value) => {
                                                                                    if (!value) return true;
                                                                                    const allowedTypes = [
                                                                                        'text/csv',
                                                                                        'application/csv',
                                                                                        'text/comma-separated-values',
                                                                                        'text/plain'
                                                                                    ];
                                                                                    const fileExtension = value?.name.split('.').pop().toLowerCase();
                                                                                    const isAllowedExtension = ['csv']?.includes(fileExtension);
                                                                                    return allowedTypes.includes(value?.type) || isAllowedExtension || 'Invalid file type. Only CSV files are accepted';
                                                                                },
                                                                                fileSize: (value) => {
                                                                                    if (!value) return true;
                                                                                    return value?.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                                                }
                                                                            }
                                                                        })}
                                                                        onChange={handleFileSelect}
                                                                        className="hidden"
                                                                        id="file-upload"
                                                                    />
                                                                    <label
                                                                        htmlFor="file-upload"
                                                                        className="inline-block bg-base-color text-white px-6 py-3 rounded-lg font-medium  transition-colors duration-200 cursor-pointer"
                                                                    >
                                                                        Select File
                                                                    </label>
                                                                </div>
                                                          )}                                       
                                                      </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="p-4">
                                                    <div className="grid py-4 mx-4 md:grid-cols-1 lg:grid-cols-2 gap-x-3 gap-y-3 customBox">
                                                        <div className="">
                                                            <label className={labelClass}>First Name</label>
                                                            <input
                                                                type="text"
                                                                className={inputClass}
                                                                {...register("firstName")}
                                                            />
                                                        </div>
                                                        <div className="">
                                                            <label className={labelClass}>Last Name</label>
                                                            <input
                                                                type="text"
                                                                className={inputClass}
                                                                {...register("lastName")}
                                                            />
                                                        </div>
                                                        <div className="">
                                                            <label className={labelClass}>Email </label>
                                                            <input
                                                                type="text"
                                                                className={inputClass}
                                                                {...register("email")}
                                                            />

                                                        </div>
                                                        {!edit && (
                                                            <>
                                                                <div className="">
                                                                    <label className={labelClass}>
                                                                        Phone Number
                                                                        <span style={{ color: "red" }}>*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className={inputClass}
                                                                        {...register("phoneNumber", {
                                                                            validate: validatePhoneNumber,
                                                                        })}
                                                                    />
                                                                    {errors.phoneNumber && (
                                                                        <Error title={errors.phoneNumber.message} />
                                                                    )}
                                                                </div>
                                                                <div className="">
                                                                    <label className={labelClass}>
                                                                        Company Name
                                                                        <span style={{ color: "red" }}>*</span>
                                                                    </label>
                                                                    <select
                                                                        placeholder="Company Name"
                                                                        className={`${inputClass} !bg-slate-100`}
                                                                        {...register("company", {
                                                                            required: true,
                                                                        })}
                                                                        onChange={(e) =>
                                                                            handleCompanySelect(e.target.value)
                                                                        }
                                                                        disabled={userDetails?.role?.roleName !== "SuperAdmin"}
                                                                    >
                                                                        <option value="">Select Company Name</option>
                                                                        {Company?.map((data) => (
                                                                            <option
                                                                                className="text-black"
                                                                                key={data?._id}
                                                                                value={data?._id}
                                                                            >
                                                                                {data?.companyName}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    {errors.company && (
                                                                        <Error title="Company Name is Required*" />
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}
                                                        <div className="">
                                                            <label className={labelClass}>
                                                               Alternate Number
                                                            </label>
                                                            <input
                                                              type="text"
                                                              className={inputClass}
                                                              {...register("alternateNumber", {
                                                                validate: validateAlternateNumber,
                                                              })}
                                                            />
                                                            {errors.alternateNumber && (
                                                              <Error title={errors.alternateNumber.message} />
                                                            )}
                                                        </div>
                                                        <div className="">
                                                            <label className={labelClass}>
                                                                Lead source
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className={inputClass}
                                                                {...register("leadSource")}
                                                            />
                                                        </div>
                                                        <div className="">
                                                            <label className={labelClass}>State</label>
                                                            <input
                                                                type="text"
                                                                className={inputClass}
                                                                {...register("state")}
                                                            />
                                                        </div>
                                                        <div className="">
                                                            <label className={labelClass}>City</label>
                                                            <input
                                                                type="text"
                                                                className={inputClass}
                                                                {...register("city")}
                                                            />
                                                        </div>
                                                        <div className="">
                                                            <label className={labelClass}>Pincode</label>
                                                            <input
                                                                type="text"
                                                                className={inputClass}
                                                                {...register("pincode")}
                                                            />
                                                        </div>
                                                        <div className="">
                                                            <label className={labelClass}>Product</label>
                                                            <input
                                                                type="text"
                                                                className={inputClass}
                                                                {...register("product")}
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className={labelClass}>Assign To</label>
                                                            <div className="form-group">
                                                                <Controller
                                                                    name="assigned_to"
                                                                    control={control}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            value={field.value || null}
                                                                            options={assignToOptions}
                                                                            placeholder="Select User"
                                                                            styles={{
                                                                                ...customStyles,
                                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                            }}
                                                                            maxMenuHeight={150}
                                                                            menuPlacement="auto"
                                                                            onChange={(selectedOption) => {
                                                                                field.onChange(selectedOption); // Update form state
                                                                                handleAssignChange(selectedOption); // Call custom function
                                                                            }}
                                                                            onInputChange={(
                                                                                inputValue,
                                                                                { action }
                                                                            ) => {
                                                                                if (action === "input-change") {
                                                                                    handleAssignChange(inputValue); // Call function on typing
                                                                                }
                                                                            }}
                                                                            {...field}
                                                                        />
                                                                    )}
                                                                />
                                                            </div>
                                                        </div>
                                                        {!edit && (
                                                            <div>
                                                                <label className={labelClass}>Remark</label>
                                                                <input
                                                                    type="text"
                                                                    className={inputClass}
                                                                    {...register("remark")}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                            <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                                {activeTab === "csv" ? (
                                                    csvLoader ? (
                                                        <ButtonLoader />
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                                                        >
                                                            <span className="opacity-100">Submit</span>
                                                        </button>
                                                    )
                                                ) : manualLoader ? (
                                                    <ButtonLoader />
                                                ) : (
                                                    <button
                                                        type="submit"
                                                        className={`${formBtn1} relative px-4 py-2 text-white font-bold rounded-lg flex items-center justify-center`}
                                                    >
                                                        <span className="opacity-100">
                                                            {edit ? "Update" : "Submit"}
                                                        </span>
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"
                                                    onClick={toggle}
                                                >
                                                    Close
                                                </button>
                                            </footer>
                                        </form>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}
